/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import "./PositionList.scss";
import axios from "axios";
import Filters from "../components/Filters/Filters";
import { createRegion } from "../components/CreateRegion/createRegion";

const PostGrid = () => {
  const [axiosData, setAxiosData] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("region-all");

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://sheets.googleapis.com/v4/spreadsheets/1ViAWBU6rAfU3EIEpjaCAP6aDJEIxmZVV4YJ3vxJEFYo/values/2:9999?key=AIzaSyDw5asg8ciaDk7CWwxQHBuKD3DzKSHRZfE"
      );
      setAxiosData(response.data);
      // setLoading(false);;
    };

    fetchData();
  }, []);

  const sendHeightToParent = () => {
    const iframe = window.frameElement; // Get reference to the iframe element
    const contentDocument = iframe.contentDocument; // Access the content document

    if (contentDocument) {
      // Use the content document's body or another element to calculate height
      const contentHeight = contentDocument.body.scrollHeight;

      // Send the height to the parent
      window.parent.postMessage(
        { type: "resizeIframe", height: contentHeight },
        "*"
      );
    }
  };

  useEffect(() => {
    sendHeightToParent();
  }, []);

  useEffect(() => {
    sendHeightToParent();
  }, [selectedFilter]);

  const allCategories = axiosData?.values.map((c) => c[4]);
  const uniqueCategories = [...new Set(allCategories)];
  const allRegions = axiosData?.values.map((c) => c[5]);
  const allUniqueRegions = [...new Set(allRegions)];

  // useEffect(() => {
  //   if (selectedFilter === "all-regions") {
  //     window.parent.location.href = `https://jsi.gtmstaging.com/position-list/#all-regions`;
  //   } else {
  //     window.parent.location.href = `https://jsi.gtmstaging.com/position-list/#${selectedFilter}`;
  //   }
  // }, [selectedFilter]);

  return (
    <div className="position-list">
      <Filters regions={allUniqueRegions} onFilterChange={setSelectedFilter} />
      {uniqueCategories?.map((reg, index) =>
        createRegion(reg, axiosData, selectedFilter)
      )}
    </div>
  );
};

export default PostGrid;
